import lodash from 'lodash';

import type { LinkPreviewData } from './../../ricos-schema/legacy/wix/rich_content/v1';

import type { LinkPreviewProviders } from '../consts';
import { DEFAULTS } from '../defaults';
import type { LinkPreviewPluginEditorConfig } from '../types';

export const fetchLinkPreview = async (
  fetchData: LinkPreviewPluginEditorConfig['fetchData'],
  url: string
): Promise<LinkPreviewData & { fixedUrl: string }> => {
  const fixedUrl = url.split('\u21b5').join(''); //remove {enter} char
  const { thumbnail_url, title, description, html } = (await fetchData?.(fixedUrl)) || {};
  return { thumbnailUrl: thumbnail_url, title, description, html, fixedUrl };
};

export const createLinkPreviewData = async (
  linkData: {
    url: string;
    target?: string;
    rel?: string;
  },
  { thumbnailUrl, title, description, html, fixedUrl }: LinkPreviewData & { fixedUrl: string },
  linkPreviewConfig?: LinkPreviewPluginEditorConfig
) => {
  const currentConfig = { ...DEFAULTS, ...linkPreviewConfig }.config;
  const data = {
    config: {
      ...currentConfig,
      link: { ...currentConfig.link, ...lodash.pickBy(linkData), url: fixedUrl },
      width: html && 350,
    },
    thumbnail_url: thumbnailUrl,
    title,
    description,
    html,
  };
  if (thumbnailUrl && (await isValidImgSrc(thumbnailUrl))) {
    data.thumbnail_url = thumbnailUrl;
  }
  return data;
};

const isValidImgSrc = (url: string): Promise<boolean> => {
  return new Promise<boolean>(resolve => {
    const image = document.createElement('img');
    image.src = url;
    image.onload = () => {
      resolve(true);
    };
    image.onerror = () => {
      resolve(false);
    };
  });
};

export const shouldAddLinkPreview = (title?: string, enableLinkPreview?: boolean) =>
  enableLinkPreview && title;

export const shouldAddEmbed = (
  html: string | undefined,
  enableEmbed: boolean | LinkPreviewProviders[],
  url: string
) => {
  if (Array.isArray(enableEmbed)) {
    return (
      enableEmbed.filter(whiteListType => url.toLowerCase().includes(whiteListType.toLowerCase()))
        .length > 0
    );
  }
  return html && enableEmbed;
};
